import {AbstractController} from "../../../controllers/AbstractController";
import {INotificationListController, MK_NOTIFICATION_LIST} from "./INotificationListController";
import {inject, Injectable, Renderer2, signal} from "@angular/core";
import {AppEventBus} from "../../../event-buses/app.event-bus";
import {AppEventName} from "../../../event-buses/AppEventName";
import {AppEvent} from "../../../event-buses/AppEvent";
import {AlertInstance} from "../../../interfaces/domain/alert/AlertInstance";
import {Helper} from "../../../helpers/Helper";
import {SessionStorageRepository} from "../../../repositories/session-storage.repository";

@Injectable()
export class AbstractNotificationListController extends AbstractController implements INotificationListController {

  protected readonly renderer = inject(Renderer2);

  protected readonly appEventBus = inject(AppEventBus);
  protected readonly sessionStorageRepository = inject(SessionStorageRepository);

  private mobileView: boolean = false;

  constructor() {
    super();

    this.addModel(MK_NOTIFICATION_LIST, {
      alertInstances$: signal(this.sessionStorageRepository.getAlertInstances()),
    });

    this.screenSizeAware();

    this.sub(this.appEventBus.subscribe(AppEventName.AlertNotification, (event) => this.onAlertNotification(event)));
    this.sub(this.appEventBus.subscribe(AppEventName.AlertSelection, (event) => this.onAlertSelection(event)));
  }

  override enterMobileView(): void {
    this.mobileView = true;
  }

  override exitMobileView(): void {
    this.mobileView = false;
  }

  handleNotificationListToggled(eventData: any) {
    this.appEventBus.dispatch(new AppEvent(AppEventName.NotificationListToggled, {}));

    this.fixNotificationListPosition();
  }

  protected fixNotificationListPosition(): void {
    setTimeout(() => {
      const element = this.getDocument().querySelector('.notification-list-overlay-panel');
      if(element) {
        if(this.mobileView) {
          this.renderer.setStyle(element, 'position', 'fixed');
          this.renderer.setStyle(element, 'top', 'unset');
          this.renderer.setStyle(element, 'bottom', '75px');
          this.renderer.setStyle(element, 'right', '0');
          this.renderer.setStyle(element, 'left', '0');
          this.renderer.setStyle(element, 'max-width', '100vw');
        }
        else {
          this.renderer.setStyle(element, 'position', 'fixed');
          this.renderer.setStyle(element, 'top', '75px');
          this.renderer.setStyle(element, 'bottom', 'unset');
          this.renderer.setStyle(element, 'right', '25px');
          this.renderer.setStyle(element, 'left', 'unset');
          this.renderer.setStyle(element, 'max-width', '400px');
        }
      }
    }, 0);
  }

  handleRemoveAlertInstance(eventData: any): void {
    const targetInstance = eventData['alertInstance'];

    if(targetInstance) {
      this.removeAlertInstance(targetInstance);
    }
  }

  handleRemoveAll(eventData: any): void {
    this.getModel(MK_NOTIFICATION_LIST).alertInstances$.set([]);
    this.sessionStorageRepository.removeAlertInstances();
  }

  handleNavigateToAlertMonitor(eventData: any): void {
    const event = eventData['event'];

    this.navigate('/alerts', event);
  }

  onAlertNotification(event: AppEvent): void {
    if(event.eventData['alert']) {
      const alertInstance: AlertInstance = event.eventData['alert'];

      if(alertInstance.state === 'OPEN') {
        this.appendAlertInstance(alertInstance);
      }
    }
  }

  onAlertSelection(event: AppEvent): void {
    if(event.eventData['alert']) {
      const alertInstance: AlertInstance = event.eventData['alert'];

      this.removeAlertInstance(alertInstance);
    }
  }

  protected appendAlertInstance(alertInstance: AlertInstance): void {
    const model = this.getModel(MK_NOTIFICATION_LIST);
    const alertInstances = model.alertInstances$();
    const newAlertInstances = Helper.arrayCopy(alertInstances);

    newAlertInstances.unshift(alertInstance);

    model.alertInstances$.set(newAlertInstances);
    this.sessionStorageRepository.saveAlertInstances(newAlertInstances);
  }

  protected removeAlertInstance(alertInstance: AlertInstance): void {
    const model = this.getModel(MK_NOTIFICATION_LIST);
    const alertInstances = model.alertInstances$();

    const newAlertInstances = alertInstances.filter((e) => e.id !== alertInstance.id);

    model.alertInstances$.set(newAlertInstances);
    this.sessionStorageRepository.saveAlertInstances(newAlertInstances);
  }
}
